import React, { Component, PropTypes } from 'react';
import axios from 'axios';
import qs from 'qs';
import baseUrl from '../../../utils/baseUrl';

import Form from '../../form/form';
import InputRange from '../../form/range/range';
import InputText from '../../form/input/text';
import InputCheckbox from '../../form/input/checkbox';
import InputTextarea from '../../form/input/textarea';
import InputSubmit from '../../form/input/submit';
import ConfirmDialog from '../../form/confirm';

export default class JuryVoteFOTD extends Component {
	static propTypes = {
		item: PropTypes.object.isRequired,
		onSubmit: PropTypes.func.isRequired,
	};

	static defaultProps = {
		onSubmit: () => {},
	};

	constructor(props) {
		super(props);

		this.state = {
			waiting: false,
			showWarning: false,
			value: 80,
			reported: false,
		};
	}

	render() {
		let PATH = '/api/account/jury/fotd/vote';
		let className = 'span14-tablet span14-mobile account-jury__entry__col3 account-jury__entry__votation';
		const item = this.props.item;

		let rangeSliderClass = '';

		if (this.props.browser.window.width < 720) {
			rangeSliderClass += 'custom-range--variable';
		} else if (this.props.browser.window.width < 1440) {
			rangeSliderClass += 'custom-range--maxi';
		}

		return (
			<div className={className}>
				<ConfirmDialog ref='confirm' />
				<Form getRefs={() => this.getRefs()} disableErrors={true} method='post' action={PATH} onSubmit={this.onSubmit.bind(this)}>
					<InputText name='id' ref='id' type='hidden' value={item.id} />
					<InputText name='point' ref='point' type='hidden' value={this.state.value} />

					<div className='account-jury__entry__votation__top pixel-pattern pixel-pattern--01'>
						<div className='account-jury__entry__votation__top__fotd-range'>
							<InputRange className={rangeSliderClass} name='point-range' value={this.state.value} extraData={{ id: item.id }} nobContent={JuryVoteFOTDWarning} onChange={this.onChange.bind(this)} />
						</div>
						<div className='account-jury__entry__votation__top__fotd-input'>
							<InputText name='points' type='number' max={100} min={0} value={this.state.value} onChange={this.onChange.bind(this)} />
						</div>
					</div>
					<div className='account-jury__entry__votation__bottom '>
						<InputCheckbox name='nominateTCEA' ref='nominateTCEA'>Nominate project for Adobe TCEA</InputCheckbox>
						<span className='account-jury__entry__votation__bottom__report' onClick={() => this.reportBroken({ id: item.id })}>
							{this.state.reported ? 'Reported' : 'Report broken link'}
						</span>
						<div className='account-jury__entry__votation__comment'>
							<InputTextarea name='comment' ref='comment' placeholder='Any comments or messages for Rob?' className='account-jury__entry__votation__comment__textarea' span='span100p' />
							<div className='account-jury__entry__votation__comment__vote'>
								<div className='account-jury__entry__votation__comment__vote__flex'>
									<InputSubmit name='Submit your vote' value='Submit your vote' waiting={this.state.waiting} className='button--light' />
								</div>
							</div>
						</div>
					</div>
				</Form>
			</div>
		);
	}

	getRefs() {
		return this.refs;
	}

	onSubmit(promise) {
		this.setState({ ...this.state, waiting: true });
		this.props.onSubmit(
			new Promise((resolve, reject) => {
				promise.then((res) => {
					this.setState({ ...this.state, waiting: false });
					resolve(res);
				}).catch((res) => {
					this.setState({ ...this.state, waiting: false });
					reject(res);
				})
			})
		);
	}

	onChange(val) {
		let newVal = val;
		newVal = parseInt(newVal, 10);
		newVal = isNaN(newVal) ? '' : newVal;
		this.setState({
			...this.state,
			value: Math.max(Math.min(100, newVal), 0),
		});
	}

	reportBroken(data = {}) {
		if (!this.state.reported && this.refs.confirm) {
			this.refs.confirm.confirm('Are you sure you want to report this link site as broken?')
			.then(() => {
				this.setState({
					...this.state,
					reported: true,
				});

				axios.post(`${baseUrl}/api/account/jury/report`, qs.stringify(data));
			})
			.catch(() => {});
		}
	}

}


class JuryVoteFOTDWarning extends Component {
	constructor(props) {
		super(props);

		this.state = {
			notBroken: false,
		};
	}

	render() {
		let className = 'account-jury__entry__warning';
		if (!(this.props.value <= 40) || this.state.notBroken) {
			className += ' account-jury__entry__warning--hide';
		}

		return (
			<div className={className}>
				<p>Is the link broken? If so, click YES to report broken link and DO NOT submit a score. Please try to judge again later.</p>

				<div className='account-jury__entry__warning__buttons'>
					<a className='button button--light' onClick={(e) => this.bindReportBroken(e, true)}>
						Yes - report broken link
					</a>
					<a className='button button--dark' onClick={(e) => this.bindReportBroken(e, false)}>
						No
					</a>
				</div>

				<div className='account-jury__entry__warning__arrow' style={{ left: (this.props.value > 6 ? this.props.value : 6) + '%' }}></div>
			</div>
		);
	}

	bindReportBroken(e, val) {
		e.preventDefault();
		this.reportBroken(val);
	}

	reportBroken(val) {
		if (val) {
			axios.post(`${baseUrl}/api/account/jury/report`, qs.stringify(this.props.data || {}));
		}

		this.setState({
			notBroken: true,
		});
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/account/jury/juryVoteFOTD.js
 **/